var React = require('react');

function IconFaq6 (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"3","d":"M11.0725 39.8513H6.50112C5.2887 39.8513 4.12594 39.3697 3.26863 38.5123C2.41132 37.655 1.92969 36.4923 1.92969 35.2799V5.56557C1.92969 4.35315 2.41132 3.19039 3.26863 2.33308C4.12594 1.47577 5.2887 0.994141 6.50112 0.994141H38.5011C39.7135 0.994141 40.8763 1.47577 41.7336 2.33308C42.5909 3.19039 43.0725 4.35315 43.0725 5.56557V35.2799C43.0725 36.4923 42.5909 37.655 41.7336 38.5123C40.8763 39.3697 39.7135 39.8513 38.5011 39.8513H33.9297M33.9297 23.8513H11.0725M33.9297 14.7084H11.0725M18.5011 37.5656L21.9297 40.9941L27.644 35.2799","stroke":"#ffffff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconFaq6.defaultProps = {"width":"45","height":"42","viewBox":"0 0 45 42","fill":"none"};

module.exports = IconFaq6;

IconFaq6.default = IconFaq6;
